import { ButtonGhostV2, DropdownSingle, LoaderCircleV2, LoaderOverlay } from "oolib";
import React, { Fragment, useState } from "react";
import {
  StyledActionsWrapper,
} from "../styled";
import { Search } from "./Search";
import { Sort } from "./Sort";
import { DataDownloadModal } from "../../DataDownloadModal";


export const MobilePanel = ({
  filtersExist,
  showSearchInput,
  showSortDropdown,
  activeSort,
  setActiveSort,
  sortConfig,
  showSideBarLeft,
  setShowSideBarLeft,
  getDataToBeExported,
  searchTermInputText,
  handleSearch,

  enableListingStyleSwitcher,
  setListingStyle,
  listingStyle
}) => {
  const [showSearchInputMobile, setShowSearchInputMobile] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [showDatadownloadModal, setShowDataDownloadModal] = useState(false)
  
  const listingStyleSwitcherOptions = [
    {icon: 'Table', display:'Table', value:'TableStyle'},
    {icon: 'Cards', display:'Cards', value:'CardsStyle'},
    {icon: 'ListDashes', display:'List', value:'ListStyle'}
  ]
  return (
    <Fragment>
      {exporting && <LoaderOverlay loaderText="Your download is in progress. Please don't leave this page." />}
      {showDatadownloadModal && <DataDownloadModal setShowDataDownloadModal={setShowDataDownloadModal} getDataToBeExported={getDataToBeExported} setExporting={setExporting} />}
      <StyledActionsWrapper>
        {/* Search */}
        {showSearchInputMobile ? (
          <div style={{ width: "100%" }}>
            <Search 
              isMobile={true}
              onClose={() => setShowSearchInputMobile(false)}
              searchTermInputText={searchTermInputText}
              handleSearch={handleSearch}
            />
          </div>
        ) : (
        <Fragment>
          <div style={{ display: "flex", alignItems: "center" }}>
            {/* Filter */}
            {filtersExist && (
              <ButtonGhostV2
                icon="Funnel"
                onClick={() => setShowSideBarLeft(!showSideBarLeft)}
                iconSize={'M'}
                style={{ width: "45px", height: "45px" }}
              />
            )}

            {/* Search Button */}
            {showSearchInput && (
              <ButtonGhostV2
                icon="MagnifyingGlass"
                onClick={() => setShowSearchInputMobile(true)}
                iconSize={'M'}
                style={{ width: "45px", height: "45px" }}
              />
            )}

            {/* Sort */}
            {showSortDropdown &&
              <Sort 
                {...{
                  sortConfig,
                  activeSort,
                  setActiveSort,
                  genCustomSelectComp : () => (
                    <ButtonGhostV2
                      icon="SortDescending"
                      iconSize={'M'}
                      style={{ width: "45px", height: "45px" }}
                    />
                  )
                }}
              />}

              {enableListingStyleSwitcher && 
              
              <DropdownSingle
                value={listingStyle}
                options={listingStyleSwitcherOptions}
                saveValueAsString
                onChange={(k,v) => setListingStyle(v)}
                genCustomSelectComp={() => (
                    <ButtonGhostV2
                      icon={listingStyleSwitcherOptions.find(op => op.value === listingStyle)?.icon}
                      iconSize={'M'}
                      style={{ width: "45px", height: "45px" }}
                    />
                  )}
                />
              }
          </div>

            {/* Download */}
            {getDataToBeExported && (
              exporting ? (
                <div style={{ width: "45px", height: "45px" }}>
                  <LoaderCircleV2 S />
                </div>
              ) : (
                <ButtonGhostV2
                  icon="ArrowLineDown"
                  onClick={() => setShowDataDownloadModal(true)} 
                  iconSize={'M'}
                  style={{ width: "45px", height: "45px" }}
                />
              )
            )}

            
        </Fragment>
      )}
    </StyledActionsWrapper>
    </Fragment>
    
  );
};

